import React from 'react';
import { Button } from '@eatclub-apps/ec-component-library';

export const SecondaryButton = ({ children, style, ...props }) => (
  <Button
    {...props}
    type='secondary'
    style={{
      ...style,
      button: {
        color: '#E54439',
        borderColor: '#E54439',
        fontWeight: 'normal',
        padding: '10px 20px',
        fontSize: '14px',
        lineHeight: '20px',
        ...style?.button,
      },
    }}
  >
    {children}
  </Button>
);
